<!--
  Sidebar menu row.
  - menu-list-item--child : styling hook for sub-items (text-only, indented)
  - active-link           : this row is the selected tab
  - has-active-child      : a child of this row is selected (e.g. 'details-client' under 'details'),
                            so the parent stays highlighted
  - matTooltip            : item name to the right of the icon, only in the icon-only collapsed rail
-->
<mat-list-item class="menu-list-item" *ngIf="menuItem.isVisible" (click)="onSelectTab(menuItem.id)"
  [class.menu-list-item--child]="depth > 0"
  [class.active-link]="selectedTab === menuItem.id"
  [class.has-active-child]="menuItem.children && selectedTab?.startsWith(menuItem.id + '-')"
  [matTooltip]="menuItem.name" matTooltipPosition="right" matTooltipClass="nav-rail-tooltip"
  [matTooltipDisabled]="!isRailCollapsed" [matTooltipShowDelay]="200">
  <mat-icon matListItemIcon class="nav-icon">{{ menuItem.icon }}</mat-icon>
  <span matListItemTitle *ngIf="isExpanded">{{ menuItem.name }}</span>
  <!-- Trailing chevron (parents only): the only control that collapses/expands the section.
       Rotated 90deg via .arrow--open when the children are shown. -->
  <mat-icon matListItemMeta class="arrow" *ngIf="menuItem.children" [class.arrow--open]="isShowChild"
    (click)="toggleChildren($event)">chevron_right</mat-icon>
</mat-list-item>
<!-- Children; .submenu draws the vertical guide line next to them -->
<div class="submenu" *ngIf="isShowChild">
  <app-menu-list-item *ngFor="let child of menuItem.children" [menuItem]="child" [depth]="depth+1"
    [isRailCollapsed]="isRailCollapsed" [(selectedTab)]="selectedTab" (selectTab)="onSelectTab($event)">
  </app-menu-list-item>
</div>
